import { Exception } from 'common/exceptions/Exception';

export class OutlookApiException extends Exception {
  apiResponse: unknown;
  constructor(message: string, apiResponse: unknown) {
    super(message);
    this.apiResponse = apiResponse;
  }
}
